function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 17.653"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4941",
  "data-name": "Group 4941"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4940",
  "data-name": "Group 4940",
  clipPath: "url(#clip-path)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2645",
  "data-name": "Path 2645",
  d: "M13.447 9H12v.875a5.74 5.74 0 011.447-.688z",
  transform: "translate(-3.317 -2.488)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2077",
  "data-name": "Rectangle 2077",
  transform: "translate(2.894 4.342)",
  d: "M0 0h1.447v6.512H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2646",
  "data-name": "Path 2646",
  d: "M1.447 13.024V1.447h7.236v2.894h2.894v2.11c.091 0 .181-.014.273-.014a5.822 5.822 0 011.174.12V3.618L9.406 0H.724A.724.724 0 000 .718v13.035a.724.724 0 00.718.718h5.794a5.74 5.74 0 01-.392-1.447z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2647",
  "data-name": "Path 2647",
  d: "M9.447 11H8v2.894h.444a5.756 5.756 0 011-2.108z",
  transform: "translate(-2.212 -3.04)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2648",
  "data-name": "Path 2648",
  d: "M9 14.844a5.427 5.427 0 115.3 5.435A5.437 5.437 0 019 14.844m5.433.016c.03 0 .059-.005.089-.005h4.545a4.615 4.615 0 00-4.634-4.639c0 .033-.005.065-.005.1v4.3c0 .085.007.171.009.255-.026 0-.052-.007-.077-.007h-4.5a.791.791 0 00-.083.009 4.611 4.611 0 004.647 4.621v-.131-3.726c0-.257 0-.513.007-.769",
  transform: "translate(-2.488 -2.605)"
})))));